<ng-container *ngIf="pwaInstallAllowed">
  <div class="px-5 pb-9 bg-neutral-100">
    <app-push-text-button-atom
      *ngIf="textWithButtonItem"
      [title]="textWithButtonItem.title"
      [text]="textWithButtonItem.text"
      [textButton]="textWithButtonItem.button.text"
      [backgroundUrl]="textWithButtonItem.background"
      [imgUrl]="textWithButtonItem.img"
      (buttonClick)="installPwa()"
    ></app-push-text-button-atom>
  </div>
</ng-container>
